export default "__VITE_ASSET__CoGl5R2U__"